import { UserOutlined } from "@ant-design/icons";
import { Avatar } from "antd";
import { getDataAnswer } from "features/private-chat/store/slice";
import moment from "moment";
import { useEffect, useMemo } from "react";
import { useSelector } from "react-redux";
import LoadingAnswer from "../LoadingAnswer";

import styles from './styles.module.scss';

import LogoLG from 'assets/img/IconLGx32.png';
import { useLocation } from "react-router-dom";
import { getCurrentUser } from "features/auth/store/slice";
import MarkdownWithMermaid from "./markdownWithMermaid";

export interface ChatViewPageProps {
  onDone(status: boolean): void;
}

const ChatView = (props: ChatViewPageProps) => {
  const { data, loading } = useSelector(getDataAnswer);
  const user = useSelector(getCurrentUser);
  const location = useLocation();

  const chatbotName = useMemo(() => {
    const path = location.pathname.split("/")[1];
    switch (path) {
      case "security-copilot":
        return "Security Copilot";
      case "api-copilot":
        return "API Copilot";
      case "audit-copilot":
        return "Audit Copilot";
      case "monitoring-copilot":
        return "AI monitoring Copilot";
      case "security-management":
        return "AI Monitoring Copilot";
      default:
        return "Security Copilot";
    }
  }, [location.pathname]);

  useEffect(() => {
    const chatElement = document.getElementById(
      "chat_message_list"
    ) as HTMLElement;
    if (chatElement) {
      setTimeout(() => {
        chatElement.scrollBy({
          top: chatElement.scrollHeight,
          left: 0,
          behavior: "smooth",
        });
      }, 200);
    }
  }, [data]);

  const memoizedMessages = useMemo(() => {
    return data?.map((message: any, idx: number) => {
      const isOwner = message.type === "in";
      const messageClass = isOwner ? styles.current_user : styles.other_user;

      return (
        <div key={idx} className={messageClass}>
          <div className={styles.infor}>
            {!isOwner && (
              <>
                <img src={LogoLG} alt="" style={{ width: "36px" }} />
                <div className={styles.name}>{chatbotName}</div>
              </>
            )}
            <div className={styles.timeStyle}>
              {moment(message.time_request).format("h:mm A")}
            </div>
            {isOwner && (
              <>
                <div className={styles.name}>
                  {user?.last_name} {user?.first_name}
                </div>
                <Avatar className={styles.avatar} icon={<UserOutlined />} />
              </>
            )}
          </div>
          {isOwner ? (
            <div
              className={styles.text}
              dangerouslySetInnerHTML={{ __html: message.answer }}
            ></div>
          ) : (
            <div className={styles.text}>
              <MarkdownWithMermaid key={data.length} content={message.answer} />
            </div>
          )}
        </div>
      );
    });
  }, [data, chatbotName, user]);

  return (
    <div className={styles.chat_message_list} id="chat_message_list">
      <div>
        <LoadingAnswer
          isHidden={true}
          chatbotName={chatbotName}
        />
      </div>
      {memoizedMessages}
      <LoadingAnswer isHidden={!loading} chatbotName={chatbotName} />
    </div>
  );
};

export default ChatView;
